/* Ancestral Brotherhood — the quote well.
 *
 * 200 lines. Two kinds, and the distinction matters legally as much as tonally:
 *
 *   s: "Hávamál" / "Eddic"  — my own plain-English renderings of the sense of
 *      the Old Norse wisdom poems. The poems are ~13th century and long out of
 *      copyright, but published TRANSLATIONS are not, so nothing here is lifted
 *      from Bellows, Hollander, Larrington or any other translator.
 *
 *   s: ""                   — written for this brand. Not attributed to anyone,
 *      because a motivational line falsely hung on a real person is both a lie
 *      and a liability. Nothing in this file quotes a living or modern figure.
 *
 * One is drawn at random per visit. No network call — this ships as a theme
 * asset alongside the app.
 */
window.AB_QUOTES = [
  { t: "Cattle die. Kinsmen die. The name a man earns never dies.", s: "Hávamál" },
  { t: "The fool lies awake all night worrying. He rises worn out, and the trouble is exactly where he left it.", s: "Hávamál" },
  { t: "A man should not walk a step from his weapons. You never know on which road you will need them.", s: "Hávamál" },
  { t: "Praise the day at evening, the ice when you are across it, the ale when it is drunk.", s: "Hávamál" },
  { t: "Better a humble house that is yours than begging at a great one.", s: "Hávamál" },
  { t: "Two goats and a patched roof beat asking another man for bread.", s: "Hávamál" },
  { t: "No man is so good he has no faults, none so bad he is worth nothing.", s: "Hávamál" },
  { t: "The unwise man thinks he will live forever if he keeps away from war. Old age gives him no peace though spears do.", s: "Hávamál" },
  { t: "A wise man asks and answers. What one man knows, keep to yourself and one other.", s: "Hávamál" },
  { t: "Wealth is a fickle friend. It is the only friend that fails without warning.", s: "Hávamál" },
  { t: "He who would win must rise early. A sleeping wolf gets no meat.", s: "Hávamál" },
  { t: "Middling wise is best. Do not look too far into your own fate and sleep the sounder for it.", s: "Hávamál" },
  { t: "A guest needs water, a towel, a welcome, and a chance to speak.", s: "Hávamál" },
  { t: "There is no worse burden on the road than too much drink.", s: "Hávamál" },
  { t: "Silence is not weakness. The listening man learns; the loud one repeats himself.", s: "Hávamál" },
  { t: "Give a gift and expect one. Friendship kept only on one side does not last.", s: "Hávamál" },
  { t: "Go often to a friend's house. The path you do not walk grows over with grass.", s: "Hávamál" },
  { t: "Better to be alive than dead. The dead man gathers nothing.", s: "Hávamál" },
  { t: "Fire is best for the sons of men, and the sight of the sun, and health, and a life lived without shame.", s: "Hávamál" },
  { t: "The cowardly man thinks he will live forever if he avoids the fight. He is wrong about that too.", s: "Hávamál" },
  { t: "Wisdom is not carried in the load. It is carried in the man.", s: "Hávamál" },
  { t: "Ask well, answer well, and men will call you wise.", s: "Hávamál" },
  { t: "Nobody is so rich they should refuse to accept, or so poor they cannot give.", s: "Hávamál" },
  { t: "Half a loaf and a tilted cup won me more friends than gold ever did.", s: "Hávamál" },
  { t: "A man's own hands are the surest tools he will ever own.", s: "Hávamál" },
  { t: "Do not mock the grey-haired. What the old man says has often been paid for.", s: "Hávamál" },
  { t: "The worst plague to any man is to be unhappy with himself.", s: "Hávamál" },
  { t: "Better to carry a small load well than a great one badly.", s: "Hávamál" },
  { t: "It is better to live than not to live. Rise, then, and be counted among the living.", s: "Eddic" },
  { t: "Fate is laid down for every man. What is left to him is how he meets it.", s: "Eddic" },
  { t: "The Norns cut what they cut. Bear it standing.", s: "Eddic" },
  { t: "A man dies once. A coward dies at every doorway.", s: "Eddic" },
  { t: "Hard is the road. Harder still is the road not walked.", s: "Eddic" },
  { t: "What is bound with iron may be broken. What is bound with will may not.", s: "Eddic" },
  { t: "The axe forgets. The tree remembers.", s: "Eddic" },
  { t: "Winter tests the house that summer built.", s: "Eddic" },
  { t: "A shield is only as strong as the arm behind it.", s: "Eddic" },
  { t: "Do not ask for a lighter load. Ask for a broader back.", s: "" },
  { t: "The barbell does not care how you feel about it.", s: "" },
  { t: "Discipline is what you do when nobody would blame you for stopping.", s: "" },
  { t: "You will not rise to the occasion. You will fall to the standard you kept in private.", s: "" },
  { t: "Motivation is a guest. Discipline lives here.", s: "" },
  { t: "The set you skip is the one that would have changed you.", s: "" },
  { t: "Do it tired. That is the whole secret and nobody wants it.", s: "" },
  { t: "Nobody is coming. Load the bar.", s: "" },
  { t: "The man you want to be is on the other side of a session you do not feel like doing.", s: "" },
  { t: "Show up on the bad days. The good days take care of themselves.", s: "" },
  { t: "Suffering chosen is training. Suffering avoided is decay.", s: "" },
  { t: "You are not tired. You are untested.", s: "" },
  { t: "Comfort is a slow thief. It takes your strength one easy day at a time.", s: "" },
  { t: "Iron tells the truth. It has no reason to flatter you.", s: "" },
  { t: "Progress is boring. That is why so few men have it.", s: "" },
  { t: "A hard hour buys an easy year.", s: "" },
  { t: "Your body will quit a hundred times before it is finished. Do not believe it.", s: "" },
  { t: "The last rep is the only one that was ever the point.", s: "" },
  { t: "Strength is a debt you repay daily or lose entirely.", s: "" },
  { t: "You cannot negotiate with gravity. Stop trying and start pulling.", s: "" },
  { t: "There is no version of this where it gets easier. There is only a version where you get harder.", s: "" },
  { t: "Do not count the days. Count the sessions.", s: "" },
  { t: "Every man is one decision from the road back. Make it now.", s: "" },
  { t: "The gym is not where you become strong. It is where you find out.", s: "" },
  { t: "Train like the man you will need to be, not the one you are.", s: "" },
  { t: "A weak man with an excuse is still a weak man.", s: "" },
  { t: "Nothing you are proud of came easily. Remember that at rep eight.", s: "" },
  { t: "Consistency beats intensity every week of the year.", s: "" },
  { t: "The plan you follow beats the plan you admire.", s: "" },
  { t: "Small weights, moved honestly, build more than heavy weights moved badly.", s: "" },
  { t: "Leave your ego at the door. It has never once lifted anything for you.", s: "" },
  { t: "You are allowed to be tired. You are not allowed to be absent.", s: "" },
  { t: "The hardest lift is the door handle.", s: "" },
  { t: "Grief, anger, fear. Bring all of it. The iron takes it.", s: "" },
  { t: "A man who can suffer on purpose is difficult to break by accident.", s: "" },
  { t: "Pain passes. Skipping does not.", s: "" },
  { t: "Do the work nobody claps for.", s: "" },
  { t: "Your sons are watching what you do at six in the morning.", s: "" },
  { t: "Be the man your family would call first in a crisis.", s: "" },
  { t: "Strength is not for you. It is for the people who depend on you.", s: "" },
  { t: "A father's discipline is inherited more surely than his eyes.", s: "" },
  { t: "Do not tell your children to be strong. Let them watch you be strong.", s: "" },
  { t: "The house stands because someone carries the beam. Be that man.", s: "" },
  { t: "You are the wall between your family and the wolves. Build accordingly.", s: "" },
  { t: "Provide, protect, preside. Everything else is decoration.", s: "" },
  { t: "A man's word is his first weapon and his last one.", s: "" },
  { t: "Keep your promises to yourself. Everything else follows.", s: "" },
  { t: "Integrity is what your training looks like when nobody logs it.", s: "" },
  { t: "The man who lies to himself in the gym lies everywhere else too.", s: "" },
  { t: "Count the reps honestly. Half a rep is a whole lie.", s: "" },
  { t: "Do not confuse being busy with being useful.", s: "" },
  { t: "A quiet man who finishes is worth ten who announce.", s: "" },
  { t: "Say less. Lift more. Let the change speak.", s: "" },
  { t: "Announce nothing. Return unrecognizable.", s: "" },
  { t: "Let them wonder what you have been doing.", s: "" },
  { t: "Brotherhood is not who drinks with you. It is who trains with you at five.", s: "" },
  { t: "Iron sharpens iron. Find men who make you uncomfortable.", s: "" },
  { t: "A lone man is a rumour. A brotherhood is a fact.", s: "" },
  { t: "Stand where you said you would stand.", s: "" },
  { t: "The seat at the table is not given. It is taken up.", s: "" },
  { t: "Carry your own weight, then carry a little of someone else's.", s: "" },
  { t: "No man is finished. Some have simply stopped.", s: "" },
  { t: "Surround yourself with men who would tell you the truth about your squat.", s: "" },
  { t: "A brother who flatters you is not a brother.", s: "" },
  { t: "Hold the line for the man beside you and he will hold it for you.", s: "" },
  { t: "Sharpen someone. That is the whole point of being sharp.", s: "" },
  { t: "Discipline is the bridge between the man you are and the man you swore you would be.", s: "" },
  { t: "Nobody drifts into strength.", s: "" },
  { t: "You do not find time. You take it from something less important.", s: "" },
  { t: "There is always a reason not to. Go anyway.", s: "" },
  { t: "The alarm is not your enemy. The snooze is.", s: "" },
  { t: "Win the first hour and the day cannot get away from you.", s: "" },
  { t: "Order the day or the day will order you.", s: "" },
  { t: "A hard morning is cheap insurance against a soft life.", s: "" },
  { t: "Do the thing you are avoiding first. It is always the thing that matters.", s: "" },
  { t: "The standard you walk past is the standard you accept.", s: "" },
  { t: "Excellence is a habit with bad hours.", s: "" },
  { t: "Rest is earned, not scheduled around.", s: "" },
  { t: "Sleep like it is training. It is.", s: "" },
  { t: "Eat like a man building something.", s: "" },
  { t: "You cannot out-train a life you refuse to govern.", s: "" },
  { t: "Recovery is not the opposite of work. It is the other half of it.", s: "" },
  { t: "The deload is a weapon, not a retreat.", s: "" },
  { t: "Add a little. Repeat for years. That is the entire method.", s: "" },
  { t: "Patience is a strength lift. Train it the same way.", s: "" },
  { t: "You want it fast. It only comes slow. Decide now.", s: "" },
  { t: "Ten years of honest work is unbeatable and nobody wants to start it.", s: "" },
  { t: "The tree that grows fast rots first.", s: "" },
  { t: "Build the base. The peak has nowhere to sit otherwise.", s: "" },
  { t: "Boring work, done long enough, looks like talent.", s: "" },
  { t: "The man who trains in February is the man who is different in August.", s: "" },
  { t: "Fear is a compass. It points at the work.", s: "" },
  { t: "Do not wait to feel brave. Move first; courage catches up.", s: "" },
  { t: "The heaviest weight a man carries is the one he will not set down.", s: "" },
  { t: "Face it standing.", s: "" },
  { t: "Fear the man who has already decided.", s: "" },
  { t: "You do not conquer the fear. You outwork it.", s: "" },
  { t: "Doubt is loud in a quiet room. Get under the bar.", s: "" },
  { t: "Anxiety hates a loaded barbell.", s: "" },
  { t: "Walk toward it. Whatever it is.", s: "" },
  { t: "Better to break trying than rust waiting.", s: "" },
  { t: "The wound teaches faster than the lecture.", s: "" },
  { t: "Take the hit. Learn the lesson. Load the bar again.", s: "" },
  { t: "Failure is information, not a verdict.", s: "" },
  { t: "You missed the lift. You did not miss the point.", s: "" },
  { t: "A bad session still beats a missed one.", s: "" },
  { t: "Nobody remembers the sets you failed. You remember the weeks you quit.", s: "" },
  { t: "Start again. Start smaller. Start today.", s: "" },
  { t: "Falling down is an event. Staying down is a decision.", s: "" },
  { t: "The comeback is built in silence.", s: "" },
  { t: "Every strong man has a season he does not talk about.", s: "" },
  { t: "Injury is a detour, not a destination.", s: "" },
  { t: "Train what you can. There is always something you can.", s: "" },
  { t: "You are not starting over. You are starting with everything you learned.", s: "" },
  { t: "The bar is where it always was. Go and meet it.", s: "" },
  { t: "Yesterday's man does not train today. You do.", s: "" },
  { t: "Do not mourn the strength you lost. Go and take it back.", s: "" },
  { t: "The body follows the decision. Make one.", s: "" },
  { t: "Sweat is the cheapest thing you will ever pay with.", s: "" },
  { t: "Hard things are hard. That is not a reason.", s: "" },
  { t: "Nobody is impressed by your potential.", s: "" },
  { t: "Talk is a light load. Carry something heavier.", s: "" },
  { t: "The plan means nothing on the day you do not execute it.", s: "" },
  { t: "One more set. Then decide.", s: "" },
  { t: "Finish what you started before you plan what is next.", s: "" },
  { t: "The work is the reward. The body is the receipt.", s: "" },
  { t: "Your future self is either grateful or disappointed. You choose today.", s: "" },
  { t: "Be hard to kill and useful to have around.", s: "" },
  { t: "Strong enough to help. That is the whole standard.", s: "" },
  { t: "Build a body that could carry someone out.", s: "" },
  { t: "Train for the day you hope never comes.", s: "" },
  { t: "Capability is a form of kindness.", s: "" },
  { t: "A gentle man with strength is a shelter. A gentle man without it is a hope.", s: "" },
  { t: "Be dangerous, then choose not to be.", s: "" },
  { t: "The strongest men are the calmest. There is a reason for that.", s: "" },
  { t: "Rage is a poor training partner. Resolve never misses a session.", s: "" },
  { t: "Control your temper the way you control the eccentric.", s: "" },
  { t: "Master yourself first. Everything else is downstream.", s: "" },
  { t: "You are the only opponent who shows up every single day.", s: "" },
  { t: "Beat the man you were at this time last year.", s: "" },
  { t: "Compare your log, not your body, and not to anyone else's.", s: "" },
  { t: "The only rivalry that pays is with your own numbers.", s: "" },
  { t: "Envy is wasted effort. Spend it on the bar.", s: "" },
  { t: "Stop admiring strong men. Go and become inconvenient.", s: "" },
  { t: "Your standards are your ceiling. Raise them.", s: "" },
  { t: "Aim past what you think is possible. You will land past what is comfortable.", s: "" },
  { t: "Set a number. Chase it until it is ordinary. Set another.", s: "" },
  { t: "The record you break today was your dream last spring.", s: "" },
  { t: "Write the goal down. Vague wishes lift nothing.", s: "" },
  { t: "A goal without a date is a daydream with good manners.", s: "" },
  { t: "Measure it or you are guessing.", s: "" },
  { t: "Log the set. Memory flatters.", s: "" },
  { t: "The numbers do not lie and they do not care.", s: "" },
  { t: "Progress you did not record is progress you cannot repeat.", s: "" },
  { t: "Faith without works is a rumour.", s: "" },
  { t: "Pray, then pick it up.", s: "" },
  { t: "The body is given once. Return it used.", s: "" },
  { t: "Steward what you were given. That is not vanity, it is duty.", s: "" },
  { t: "A strong body and a weak character is a house with no roof.", s: "" },
  { t: "Train the will. The muscle is a side effect.", s: "" },
  { t: "What you build in the dark decides who you are in the light.", s: "" },
  { t: "The oath is easy. The Tuesday is hard.", s: "" },
  { t: "You swore something. Go and keep it.", s: "" },
  { t: "The seventh seat is empty because it is yours. Sit in it.", s: "" },
  { t: "Blood makes you related. Effort makes you kin.", s: "" },
  { t: "Leave the ground harder than you found it.", s: "" },
  { t: "Old men plant trees whose shade they will never sit in. Lift like one.", s: "" },
  { t: "You are an ancestor in training.", s: "" },
  { t: "Somebody suffered so you could exist. Do not waste the inheritance.", s: "" },
  { t: "Be worth remembering.", s: "" }
];
